/** Gates all ACCESS UI; fail-closed, so show it only when the flag is exactly `true`. */
export const CMS_ACCESS_ENROLLMENT_FLAG = "cms-access-enrollment";

export const ACCESS_PROGRAM_GROUP = "access";

// eckm/ckm/bh (wire) → display casing.
const PROGRAM_TRACK_LABEL: Record<string, string> = {
  eckm: "eCKM",
  ckm: "CKM",
  bh: "BH",
};

export const programTrackDisplayName = (type: string): string =>
  PROGRAM_TRACK_LABEL[type] ?? type;
